export default {
  namespaced: true,
  state: {
    username: '',
    user_roles: []
  },
  mutations: {
    setUserName(state, name) {
      state.username = name;
    },
    setUserRoles(state, roles) {
      state.user_roles = roles;
    }
  },
  actions: {
    updateUserName({commit}, {username}) {
      commit('setUserName', username);
      localStorage.setItem('username', username);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js